import { render, staticRenderFns } from "./emissions02.vue?vue&type=template&id=3ce541a2"
import script from "./emissions02.vue?vue&type=script&lang=js"
export * from "./emissions02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce541a2')) {
      api.createRecord('3ce541a2', component.options)
    } else {
      api.reload('3ce541a2', component.options)
    }
    module.hot.accept("./emissions02.vue?vue&type=template&id=3ce541a2", function () {
      api.rerender('3ce541a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/emissions02.vue"
export default component.exports